import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  styleUrls: ['./pagination.component.scss'],
  templateUrl: './pagination.component.html',
  standalone: false
})
export class PaginationComponent {
  @Input() currentPage: number;
  @Input() pages: number;
  @Input() pagesSelectionOptions: number[];
  @Output() update: EventEmitter<number> = new EventEmitter<number>();

  updatePagination(index: number): void {
    this.update.emit(index);
  }
}
